import {ajaxRequest} from "../common/Ajax";

function changePassword() {
    const form = document.getElementById('form-change-password')


    if (form === null) return;

    const inputPassCurrent = form.querySelector('input[name="password_current"]')
    const inputPassNew = form.querySelector('input[name="password_new"]')
    const btnSubmit = form.querySelector('button[type="submit"]')

    form.addEventListener('click', function (e) {
        e.preventDefault();

        // Check if the clicked element has the class "_toggle_password_visibility"
        if (e.target.classList.contains('_toggle_password_visibility')) {
            const passwordInput = e.target.previousElementSibling; // Find the previous input element

            if (passwordInput && passwordInput.type === 'password') {
                // Show password (change input type to 'text')
                passwordInput.type = 'text';
                e.target.classList.remove('esr-icon-visibility-off');
                e.target.classList.add('esr-icon-visibility-on');
            } else if (passwordInput) {
                // Hide password (change input type to 'password')
                passwordInput.type = 'password';
                e.target.classList.remove('esr-icon-visibility-on');
                e.target.classList.add('esr-icon-visibility-off');
            }
        }
    });

    inputPassNew.addEventListener('input', function () {
        const password = this.value;
        const strengthBar = document.getElementById('password-strength-bar');
        const strengthText = document.getElementById('password-strength-text');

        const feedback = getPasswordFeedback(password);

        strengthBar.value = feedback.strength;

        if (feedback.strength <= 40) {
            strengthBar.classList = 'progress progress-error';
            btnSubmit.setAttribute('disabled', 'disabled');
        } else if (feedback.strength <= 80) {
            strengthBar.classList = 'progress progress-warning';
            btnSubmit.setAttribute('disabled', 'disabled');
        } else if (feedback.strength === 100) {
            strengthBar.classList = 'progress progress-success';
            btnSubmit.removeAttribute('disabled');
        }

        strengthText.innerHTML = feedback.message;
    });

    btnSubmit.addEventListener('click', async function (e) {
        e.preventDefault();

        btnSubmit.classList.add('btn-loading');

        await ajaxRequest({
            action: 'esr_change_password',
            data: {user_id: ESR.user.id, password_current: inputPassCurrent.value, password_new: inputPassNew.value},
        })

        btnSubmit.classList.remove('btn-loading')
    })

    if (window.location.hash === '#change-password') {
        const checkbox = document.getElementById('change-password-toggle');
        checkbox.checked = true;
    }

    function getPasswordFeedback(password) {
        let strength = 0;
        let feedbackMessages = [];

        if (password.length >= 8) {
            strength += 20;
        } else {
            feedbackMessages.push("Lungimea trebuie să fie de cel puțin 8 caractere.");
        }

        if (/[A-Z]/.test(password)) {
            strength += 20;
        } else {
            feedbackMessages.push("Adăugați cel puțin o literă mare.");
        }

        if (/[a-z]/.test(password)) {
            strength += 20;
        } else {
            feedbackMessages.push("Adăugați cel puțin o literă mică.");
        }

        if (/[0-9]/.test(password)) {
            strength += 20;
        } else {
            feedbackMessages.push("Adăugați cel puțin o cifră.");
        }

        if (/[^A-Za-z0-9]/.test(password)) {
            strength += 20;
        } else {
            feedbackMessages.push("Adăugați cel puțin un simbol (de ex: @, #, $, etc.).");
        }

        return {
            strength: strength,
            message: feedbackMessages.join("<br>")
        };
    }
}

function editProfile() {

    const form = document.querySelector('.esr-profile-edit__form');
    const submitButton = document.querySelector('.esr-profile-edit__submit');

    if (form === null) return;

    // Store initial form values
    let initialValues = {};
    let changedValues = {};

    // Initialize the initial values of the form inputs
    form.querySelectorAll('input').forEach(input => {
        if (input.name) {  // Check if the input has a valid name attribute
            initialValues[input.name] = input.value;
        }
    });

    // Function to check for changes and enable/disable the submit button
    function checkChanges() {
        let hasChanges = false;
        changedValues = {}; // Reset changed values

        form.querySelectorAll('input').forEach(input => {
            if (input.name) {  // Only process inputs with a valid name attribute
                const currentValue = input.value;
                const initialValue = initialValues[input.name];

                // Check if the current value is different from the initial value
                if (currentValue !== initialValue) {
                    changedValues[input.name] = currentValue; // Store only changed values
                    hasChanges = true;
                }
            }
        });

        // Enable/disable the submit button based on changes
        submitButton.disabled = !hasChanges; // Enable if there are changes
    }

    // Attach the input event to each input field
    form.querySelectorAll('input').forEach(input => {
        input.addEventListener('input', checkChanges);
    });

    // Handle submit button click
    submitButton.addEventListener('click', async function (e) {
        e.preventDefault(); // Prevent the form from submitting normally

        submitButton.classList.add('btn-loading');

        await ajaxRequest({
            action: 'esr_update_user',
            data: {user_id: ESR.user.id, ...changedValues},
        })

        submitButton.classList.remove('btn-loading')
    });

}

export default function profile() {
    editProfile();
    changePassword();
}